const replaceCancelButtonOnClick = (document, redirectFn) => {
  if (!document) return;

  const cancelButton = [...document.querySelectorAll('button')].find(
    button => button.innerText === 'Cancel'
  );

  if (cancelButton) {
    cancelButton.onclick = () => {
      if (window.confirm('Are you sure you want to close this wizard?')) {
        redirectFn();
      }
    };
  }
};

export const replaceCancelButtonAction = ({
  iframe,
  id = 'detailsec1',
  redirectFn,
  postReplaceFn = () => {}
}) => {
  const frameNode = iframe?.contentDocument?.getElementById(id);
  const { contentDocument } = frameNode ?? {};

  const doReplace = () => {
    replaceCancelButtonOnClick(contentDocument, redirectFn);
    postReplaceFn(contentDocument);
  };

  if (contentDocument) {
    // Replace onClick functionality as soon as iframe loads
    doReplace();
    // Because this iframe is a form, when buttons are pressed the page gets reloaded, so reoverwrite onclicks
    frameNode.addEventListener('load', doReplace);
  }

  return contentDocument;
};
